import React from 'react';

import { TextField, DatePickerField, MCButton } from 'src/components/basic';
import { Table } from 'src/components/complex';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';

import { lang, remCss, scssVariables as variables, number } from 'src/helpers';

import model from './model';
import ShortInfo from 'src/components/user/ShortInfo';
import LANG_CONST from 'src/helpers/lang/const';
import PopupSelect from 'src/components/complex/popupSelect';
import { FormRow } from 'components/Form';

const apiStateId = 'create';

class AddInvoice extends BaseComponent {
  componentDidMount() {
    model.baseSubscribe(this.subscription);
    model.resetAddInvoice();
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  submit = (e) => {
    e.preventDefault();
    const { hide } = this.props;
    model.create((error, data, success) => {
      if (success) {
        data.patient = this.state.patient;
        hide();
      }
    });
  };

  inputDetail = (index, name) => (n, v) => {
    const { handleChange } = model;
    const invoiceDetails = model.input('invoiceDetails');
    model.resetApiState(apiStateId);
    const old = [...invoiceDetails];
    old[index][name] = v;
    handleChange('invoiceDetails', [...old]);
  };

  renderDetail() {
    const createState = model.getApiState(apiStateId);
    const invoiceDetails = model.input('invoiceDetails');
    const { invalid: mainInvalid } = createState;
    const invalid = mainInvalid?.invoiceDetails || {};

    return (
      <Table
        template={'3'}
        showPagination={false}
        data={invoiceDetails}
        columns={[
          {
            label: LANG_CONST.description,
            cellClassName: 'mc-value-420',
            cellStyles: { alignSelf: 'baseline' },
            render: (invoiceDetail, i) => (
              <>
                <TextField
                  template={6}
                  name={'invoiceDetail_description_' + i}
                  value={invoiceDetail.description || ''}
                  onChange={this.inputDetail(i, 'description')}
                />
                {invalid['invoiceDetail_description_' + i] && (
                  <p className='mc-form-invalid-text'>
                    {invalid['invoiceDetail_description_' + i]}
                  </p>
                )}
              </>
            )
          },
          {
            label: LANG_CONST.price,
            cellClassName: 'mc-value-420',
            cellStyles: {
              maxWidth: 200,
              paddingLeft: remCss(10),
              paddingRight: remCss(10),
              alignSelf: 'baseline'
            },
            render: (invoiceDetail, i) => (
              <>
                <TextField
                  template={6}
                  name={'invoiceDetail_price_' + i}
                  value={invoiceDetail.price || ''}
                  onChange={this.inputDetail(i, 'price')}
                  type={'money'}
                  currency={model.getCurrency()}
                />

                {invalid['invoiceDetail_price_' + i] && (
                  <p className='mc-form-invalid-text'>{invalid['invoiceDetail_price_' + i]}</p>
                )}
              </>
            )
          },
          {
            label: LANG_CONST.vat,
            cellClassName: 'mc-value-420',
            cellStyles: {
              maxWidth: 120,
              paddingLeft: remCss(10),
              paddingRight: remCss(10),
              alignSelf: 'baseline'
            },
            render: (invoiceDetail, i) => (
              <>
                <TextField
                  template={6}
                  name={'invoiceDetail_vat_' + i}
                  value={invoiceDetail.vat ? invoiceDetail.vat + '%' : ''}
                  onChange={(n, v) => this.inputDetail(i, 'vat')(n, v.toString().replace('%', ''))}
                  type={'number'}
                />

                {invalid['invoiceDetail_vat_' + i] && (
                  <p className='mc-form-invalid-text'>{invalid['invoiceDetail_vat_' + i]}</p>
                )}
              </>
            )
          },
          {
            label: LANG_CONST.total,
            cellClassName: 'mc-value-420',
            cellStyles: {
              maxWidth: 200,
              paddingLeft: remCss(10),
              paddingRight: remCss(10),
              textAlign: 'center',
              alignSelf: 'baseline'
            },
            render: (invoiceDetail) =>
              invoiceDetail.vat &&
              invoiceDetail.price &&
              !isNaN(invoiceDetail.vat) &&
              !isNaN(invoiceDetail.price)
                ? `${number.format(
                    Math.round(
                      (100 + parseFloat(invoiceDetail.vat)) * parseFloat(invoiceDetail.price)
                    ) / 100
                  )} ${model.getCurrency()}`
                : ''
          },
          {
            label: '',
            cellStyles: { maxWidth: 55, textAlign: 'end', alignSelf: 'flex-start' },
            render: (treatment, i) =>
              i > 0 && (
                <button
                  className={'mc-no-style-btn'}
                  type={'button'}
                  onClick={() => model.delInvoiceDetail([i])}
                >
                  <SVGIcon
                    iconname={BASE_ICONS.DELETE}
                    light
                    radius
                    padding={5}
                    width={50}
                    fill={variables['colors-mc-danger']}
                  />
                </button>
              )
          }
        ]}
      />
    );
  }

  render() {
    const { closeBtn } = this.props;
    const apiStateId = 'create';
    const { handleChange, handleBlur } = model;
    const { invalid, loading, ...createState } = model.getApiState(apiStateId);

    return (
      <div className={'mc-popup-contain'} style={{ maxWidth: remCss(1024), width: '100%' }}>
        <div className='mc-modal-header'>
          <div className='mc-popup-title'>{lang.t(LANG_CONST.buttons.add_invoice)}</div>
          {closeBtn}
        </div>
        <form className='mc-modal-body mc-flex-20-col' onSubmit={this.submit}>
          {createState.error && <p className='mc-error'>{createState.errorMessage}</p>}
          <FormRow>
            <TextField
              template={6}
              name={'serie'}
              label={LANG_CONST.serie}
              value={model.input('serie')}
              onChange={(n, v) => {
                model.resetApiState(apiStateId);
                handleChange(n, v);
              }}
              onBlur={handleBlur}
              invalid={invalid}
            />
            <TextField
              template={6}
              type={'number'}
              name={'invoiceNo'}
              label={LANG_CONST.invoice_no}
              value={model.input('invoiceNo')}
              onChange={(n, v) => {
                model.resetApiState(apiStateId);
                handleChange(n, v);
              }}
              onBlur={handleBlur}
              invalid={invalid}
            />
          </FormRow>
          <FormRow>
            <DatePickerField
              label={'Date'}
              template={'6'}
              icontype={2}
              placeholder={LANG_CONST.invoice_date}
              placement={'bottom-center'}
              name={'invoiceDate'}
              value={model.input('invoiceDate')}
              onChange={(n, v) => {
                model.resetApiState(apiStateId);
                model.handleChange(n, v);
              }}
              invalid={{}}
            />
            <PopupSelect
              template={6}
              isClearable={false}
              label={LANG_CONST.patient}
              isPopover={true}
              invalid={invalid}
              placeholder={LANG_CONST.select}
              name={'patientId'}
              value={model.state.patientId}
              initSelectedParamKey={'patientId'}
              apiConfig={{
                url: 'patient/refresh',
                labelFn: (user) => <ShortInfo small user={user} specialist={[]} />
              }}
              selectedLabelFn={(user) => (
                <ShortInfo
                  small
                  user={user}
                  specialist={[]}
                  style={{
                    marginTop: remCss(-3),
                    marginBottom: remCss(-3),
                    cursor: 'pointer'
                  }}
                />
              )}
              onChange={(n, v) => {
                model.resetApiState(apiStateId);
                model.handleChange('patientId', v);
              }}
            />
          </FormRow>
          <div className={'mc-flex-20-col mc-mt5'}>
            <div className={'mc-value-620'}>{lang.t(LANG_CONST.titles.invoice_details)}</div>
            {this.renderDetail()}
            <div>
              <MCButton
                medium
                primary
                light
                radius
                iconname={BASE_ICONS.PLUS}
                label={LANG_CONST.buttons.add_more}
                type={'button'}
                onClick={model.addInvoiceDetail}
              />
            </div>
          </div>
        </form>
        <div className='mc-modal-footer mc-flex'>
          <div className='mc-grow' />
          <MCButton
            medium
            primary
            light
            radius
            disabled={loading}
            type={'button'}
            onClick={this.props.hide}
            label={LANG_CONST.buttons.cancel}
          />
          <MCButton
            medium
            primary
            dark
            radius
            disabled={loading}
            loading={loading}
            type={'submit'}
            onClick={this.submit}
            label={LANG_CONST.buttons.add_invoice}
          />
        </div>
      </div>
    );
  }
}

export default AddInvoice;
